__turbopack_context__.v({
  "phone": "CZX9Jq_phone",
  "serviceErrorModal": "CZX9Jq_serviceErrorModal",
  "textContent": "CZX9Jq_textContent",
});
